
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/ecommerce",
      function () {
        return require("private-next-pages/settings/ecommerce.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/ecommerce"])
      });
    }
  